export class HousingInfo {
    constructor({
        location = null,
        address = "",
        housingType = null,
        buildingMaterial = null,
        housingAge = null,
        squareMeters = null,
        interiorNumber = "",
        hasStores = null,
        securitySystem = false,
        floorsNumber = null,
        basements = null,
        distanceTerms = null,
        exclusiveUse = null,
        addressInfo = null,
    } = {}) {
        this.location = location;
        this.address = address;
        this.housingType = housingType;
        this.buildingMaterial = buildingMaterial;
        this.housingAge = housingAge;
        this.squareMeters = squareMeters;
        this.interiorNumber = interiorNumber;
        this.hasStores = hasStores;
        this.securitySystem = securitySystem;
        this.floorsNumber = floorsNumber;
        this.basements = basements;
        this.distanceTerms = distanceTerms;
        this.exclusiveUse = exclusiveUse;
        this.addressInfo = addressInfo;
    }
}
